import React from 'react';
import { IconProps } from '.';

const SvgFold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='m17.53 18.47-1.06 1.06L12 15.06l-4.47 4.47-1.06-1.06L12 12.94l5.53 5.53ZM17.53 5.53 12 11.06 6.47 5.53l1.06-1.06L12 8.94l4.47-4.47 1.06 1.06Z'
      />
    </svg>
  );
};

export default SvgFold;
